<template>
    <div 
        style='z-index: 9999;' v-if="alertData.isOpen"
        :class="[alertData.isError ? 'bg-red-500' : 'bg-emerald-500']"
        class="alert-modal text-white px-6 py-4 border-0 rounded mb-4  absolute top-0 right-0">
            <span class="inline-block align-middle mr-8">
                <b class="">{{ alertData.message }}</b>
            </span>
        <button
            class="absolute bg-transparent text-2xl font-semibold leading-none right-0 top-0 mt-4 mr-6 outline-none focus:outline-none" 
            v-on:click="closeAlert"
            >
            <span>×</span>
        </button>
    </div>
</template>

<script>

import { mapMutations, mapState } from 'vuex'

export default {
    name: "small-modal",
    computed: mapState(['alertData']),
    data() {
        return {};
    },
    methods: {
        ...mapMutations(['modalClose']),
    },
}
</script>

<style scoped>
.alert-modal {
    position: fixed;
}
</style>